import fetch from "auth/GenericFetchInterceptorV5";

const SuppliersService = {};

SuppliersService.addSupplier = function (body) {
    return fetch({
        url: `/api/suppliers`,
        method: "POST",
        data:body
    });
};
SuppliersService.getSources = function (documentId) {
    console.log("documentiId in getSources",documentId)
    return fetch({
        url: `/api/catalog-suppliers?populate=supplier&filters[company][documentId]=${documentId}`,
        method: "GET",
    });
};

SuppliersService.getSourcesAfter = function (companyDocId, updatedAtISO) {
    return fetch({
        url: `/api/catalog-suppliers?populate=supplier&filters[company][documentId]=${companyDocId}&filters[supplier][updatedAt][$gt]=${updatedAtISO}`
    })
}

// New method to get just the count of suppliers for a company
SuppliersService.getSourcesCount = function (companyDocId) {
    return fetch({
        url: `/api/catalog-suppliers?filters[company][documentId]=${companyDocId}&pagination[pageSize]=1&pagination[page]=1`,
        method: "GET",
    });
};

SuppliersService.getCode = function (companyDocumentId) {
    return fetch({
        url: `/api/suppliers/next-account-code?companyDocumentId=${encodeURIComponent(companyDocumentId)}`,
        method: "GET",
    });
};

SuppliersService.updateSupplier = function (documentId, body) {

    return fetch({
        url: `/api/suppliers/${documentId}`,
        method: "PUT",
        data: body
    });
};

SuppliersService.deleteSource = function (documentId) {
    console.log("Elimino supplier con documentId:", documentId);
    return fetch({
        url: `/api/suppliers/${documentId}`,
        method: "DELETE"
    });
};

SuppliersService.getByDocumentIdWithRelations = function (documentId, companyDocumentId) {
    const companyQuery = companyDocumentId
        ? `&companyDocumentId=${encodeURIComponent(companyDocumentId)}`
        : '';
    return fetch({
        url: `/api/suppliers/${documentId}?populate[ddts][populate][lots][populate][product]=true&populate[ddts][populate][supplier]=true&populate[products]=true&populate[catalog_suppliers][populate][company]=true&populate[catalog_suppliers][populate][accounting_account]=true${companyQuery}`,
        method: "GET",
    });
};

export default SuppliersService;
